/**
 *
 * EditActions
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { injectIntl, intlShape } from 'react-intl';
import withUser from 'containers/User/withUser';
import withDialog from 'containers/Dialog/withDialog';
import { stack } from 'containers/EditService/reducer';
import IconButton from 'components/IconButton';
import messages from './messages';

function EditActions(props) {
  const {
    onSave,
    workingRoute,
    clearRoute,
    undo,
    user,
    intl,
    dlgConfirm,
    routeId,
  } = props;
  const title = intl.formatMessage(
    user.api ? messages.save : messages.loginFirst,
  );
  const handleClear = () => {
    const forceEmpty = routeId !== undefined;
    if (workingRoute.legs.length === 0) {
      clearRoute(forceEmpty);
      return;
    }
    dlgConfirm({
      title: messages.confirm,
    })
      .then(() => clearRoute(forceEmpty))
      .catch(() => {});
  };

  return (
    <React.Fragment>
      <IconButton
        bsStyle="success"
        icon="save"
        className="btn-fab"
        disabled={!user.api || workingRoute.legs.length === 0}
        title={title}
        onClick={onSave}
        aria-label="Save route"
      />
      <IconButton
        bsStyle="info"
        icon="undo"
        className="btn-fab"
        disabled={stack.length === 0}
        title={intl.formatMessage(messages.undo)}
        onClick={undo}
        aria-label="Undo last edit"
      />
      <IconButton
        bsStyle="danger"
        icon="times"
        className="btn-fab"
        title={intl.formatMessage(messages.clear)}
        onClick={handleClear}
        aria-label="Clear route"
      />
    </React.Fragment>
  );
}

EditActions.propTypes = {
  onSave: PropTypes.func.isRequired,
  workingRoute: PropTypes.object.isRequired,
  clearRoute: PropTypes.func.isRequired,
  undo: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  dlgConfirm: PropTypes.func.isRequired,
  routeId: PropTypes.number,
  intl: intlShape,
};

export default compose(
  withUser,
  withDialog,
  injectIntl,
)(EditActions);
